import type { ClipboardEvent, FocusEvent } from 'react';
import { useState } from 'react';
import { useProperty, useSnowplowTracking, useTranslation } from '@eti/providers';
import { ConnectedInput } from '@eti/form';
import { constants, persistInputData } from '@eti/utils';
import { TRAVELER_DETAILS } from '../../../../constants/formNamesConstants';
import { contactFields, fieldRestrictions } from '../../constants/formFields';

const { MOUSE_FLOW_CLASS_NAMES } = constants;

const EmailConfirm = () => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();
  const [hasChanged, setHasChanged] = useState(false);

  const handleOnChange = () => {
    if (isSnowplowTrackingEnabled && !hasChanged) {
      sendTrackEvent({
        category: 'Traveler Details',
        action: 'Input',
        label: 'Email-confirmation',
      });
      setHasChanged(true);
    }
  };

  const handleOnBlur = p('IbeClient.TravelerDetails.PersistFormData.Enabled')
    ? (event: FocusEvent<HTMLInputElement>) =>
        persistInputData(TRAVELER_DETAILS, contactFields.EMAIL_CONFIRM)(event.target.value)
    : undefined;

  const handleOnPaste = (event: ClipboardEvent) => {
    return p('IbeClient.ContactInformation.ConfirmationEmail.AllowPasting.Enabled')
      ? undefined
      : event.preventDefault();
  };

  return (
    <ConnectedInput
      autoCapitalize="off"
      autoComplete="no"
      autoCorrect="off"
      className={MOUSE_FLOW_CLASS_NAMES}
      data-testid="traveler-email-confirm-input"
      description={t('ContactForm.Email.ConfirmHintLabel')}
      label={t('ContactForm.Email.ConfirmLabel')}
      maxLength={fieldRestrictions.MAX_CHARS}
      name={contactFields.EMAIL_CONFIRM}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      onPaste={handleOnPaste}
      placeholder={t('Input.ConfirmMail.Placeholder')}
      shouldMarkInputAsRequired
      spellCheck="false"
      type="email"
      validationRuleName={contactFields.EMAIL_CONFIRM}
    />
  );
};

export default EmailConfirm;
